export * from '@thalesrc/js-utils/string/limit';
